import React from "react";
import { useSelector } from "react-redux";
import Error from "../../components/ui/Error";
import Loading from "../../components/ui/Loading";
import { useGetBooksQuery } from "../../features/api/apiSlice";
import BooKGridItem from "./BookGridItem/BookGridItem";

function BookGrid() {
  const { data: books, isLoading, isError } = useGetBooksQuery();
  const status = useSelector((state) => state.filter);
  // console.log(books);
  const { feature, search } = status;
  // console.log(feature, search);
  // decide what to render
  let content = null;

  if (isLoading) {
    content = (
      <>
        <Loading />
      </>
    );
  }

  if (!isLoading && isError) {
    content = <Error message="There was an error" />;
  }

  if (!isLoading && !isError && books?.length === 0) {
    content = <Error message="No videos found!" />;
  }

  if (!isLoading && !isError && books?.length > 0) {
    if (feature === "all")
      content = books.map((book) => {
        if (book.name.toLowerCase().includes(search.toLowerCase()))
          return <BooKGridItem key={book.id} book={book} />;
        else return "";
      });
    if (feature === "featured")
      content = books.map((book) => {
        if (
          book.featured &&
          book.name.toLowerCase().includes(search.toLowerCase())
        )
          return <BooKGridItem key={book.id} book={book} />;
        return "";
      });
  }

  //  return content;
  return (
    <div className="space-y-6 md:space-y-0 md:grid grid-cols-1 lg:grid-cols-3 gap-6">
      {/* <!-- Card 1 --> */}
      {content}
    </div>
  );
}

export default BookGrid;
